import { useEffect } from 'react';

import { DEFAULT_POLL_INTERVAL_MS } from '~/eds/src/constants/duration';
import { FlagType } from '~/flags/flags';
import { useFlag } from '~/flags/useFlag';
import { usePollingRequest } from '~/hooks/usePollingRequest';
import { api } from '~/redux/api/createApi';
import { Uuid } from '~/types/Uuid';

import { testIsTestCaseEvaluating } from '../fields/utils';
import { PromptModelTestCase } from '../types/deprecated';

export const usePollPromptModelTestCases = ({
  testCases,
  modelId,
  version,
  onUpdateTestCases,
}: {
  testCases: PromptModelTestCase[];
  modelId: Uuid;
  version: number;
  onUpdateTestCases: (testCases: PromptModelTestCase[]) => void;
}) => {
  const highlightMethod = useFlag(FlagType.CustomAiHighlightMethod);
  const isEvaluatingTestCases = testCases.some(testIsTestCaseEvaluating);

  const { data: updatedTestCases } = usePollingRequest(
    api.endpoints.getPromptModelTestCases.useQuery,
    {
      modelId,
      version,
      highlightMethod,
    },
    {
      skip: !isEvaluatingTestCases,
      pollingInterval: DEFAULT_POLL_INTERVAL_MS,
      maxRetries: 100,
    },
  );

  useEffect(() => {
    if (updatedTestCases) {
      onUpdateTestCases(updatedTestCases);
    }
  }, [modelId, version, updatedTestCases, onUpdateTestCases]);
};
